import React, { useState } from "react";
import styles from "./LjkParty.module.css";
import Reveal from "../../ReusableComponents/Reveal/Reveal";

const PARTY_URL = "https://ljkparty.com/";

/**
 * Served from `public/` rather than imported from `src/assets/`, so the build
 * does not fail while the artwork is still missing - the component falls back
 * to the monogram until the file is dropped in.
 */
const FLAG_SRC = `${process.env.PUBLIC_URL}/Flag12.png`;

/**
 * The party call-out, moved out of the header.
 *
 * It sat in the main nav alongside Home / About / Impact, which made an
 * off-site jump look like an in-page section - and the nav item also ran
 * handleActive("ljk-party"), so a click both scrolled to a non-existent
 * anchor and opened an external tab. Here it reads as what it is: a link to a
 * separate site.
 *
 * The id is kept so any existing /#ljk-party link still lands somewhere.
 */
export default function LjkParty() {
  const [flagMissing, setFlagMissing] = useState(false);

  return (
    <section id="ljk-party" className={styles.section}>
      <Reveal className={styles.band} y={32}>
        <div className={styles.flag}>
          {flagMissing ? (
            <span className={styles.mark} aria-hidden="true">
              LJK
            </span>
          ) : (
            <img
              className={styles.flagImg}
              src={FLAG_SRC}
              alt="Flag of the Lachiya Jananayaga Katchi"
              onError={() => setFlagMissing(true)}
              loading="lazy"
            />
          )}
        </div>

        <div className={styles.copy}>
          <span className={styles.eyebrow}>The party</span>
          <h2 className={styles.title}>Lachiya Jananayaga Katchi</h2>
          <p className={styles.lead}>
            The political movement behind the vision for Puducherry. Its work,
            people and announcements live on the party's own site.
          </p>

          <a
            className={styles.cta}
            href={PARTY_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>Visit ljkparty.com</span>
            <svg viewBox="0 0 16 16" aria-hidden="true">
              <path
                d="M6 3h7v7M13 3L4 12"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className={styles.srOnly}>(opens in a new tab)</span>
          </a>
        </div>
      </Reveal>
    </section>
  );
}
